import { useSite } from "@/contexts/SiteContext";
import SectionCta from "@/components/SectionCta";

/**
 * Full-width emerald CTA band — sits between Reviews and Contact.
 * Editable via /admin/sectiuni → cta_band.
 */
export default function CtaBand() {
  const { sectionContent } = useSite();
  const c = sectionContent("cta_band");
  if (!c) return null;
  const title = c.title || "Începe transformarea ta interioară astăzi.";
  const subtitle = c.subtitle || "Rezervă o sesiune și clarifică-ți primul pas.";

  return (
    <section data-testid="cta-band-section" className="w-full" style={{ background: "var(--ct-emerald)", color: "var(--ct-text-inverse)" }}>
      <div
        className="max-w-[1440px] mx-auto px-4 lg:px-12 py-7 lg:py-6 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-5 lg:gap-8"
        style={{ minHeight: "96px" }}
      >
        <div className="flex-1">
          <p data-el="title" data-field="title" className="font-serif text-2xl lg:text-3xl leading-tight" style={{ color: "#F7F5F0" }}>
            {title}
          </p>
          {subtitle && (
            <p data-el="subtitle" data-field="subtitle" className="text-sm lg:text-base mt-1.5" style={{ color: "rgba(247,245,240,0.75)" }}>
              {subtitle}
            </p>
          )}
        </div>
        <div className="flex flex-col items-start lg:items-end gap-3 shrink-0">
          <SectionCta
            content={c}
            prefix="cta"
            fallbackText="Programează o sesiune"
            fallbackLink="/contact"
            className="inline-flex items-center justify-center gap-2 h-14 px-[34px] rounded-[3px] text-base font-semibold whitespace-nowrap transition-transform hover:scale-[1.02] bg-[var(--ct-btn-primary-bg)] text-[var(--ct-btn-primary-text)] shadow-[var(--ct-shadow-gold)]"
          />
        </div>
      </div>
    </section>
  );
}
